import { createHash } from "crypto";
import { BRAND_NAME } from "./constants";
import { setCookie } from "./commonUtil";

export function getRefinedLeadInfo(leadInfo = {}) {
  return Object.values(leadInfo).reduce((prevValue, currentValue) => {
    const prevValueRef = prevValue;
    const { value, emittedBy } = currentValue;
    if (emittedBy === "phone") {
      const { dialCode, nationalNumber } = currentValue;
      prevValueRef.countryCode = dialCode;
      prevValueRef.phone = nationalNumber;
    } else {
      prevValueRef[emittedBy] = value;
    }
    return prevValueRef;
  }, {});
}

function hash(string) {
  return createHash("sha256").update(string).digest("hex");
}

function pushRegistrationToGA4DataLayer(brandName, leadId, response) {
  if (window.dataLayer) {
    window.dataLayer.push({
      brand: brandName,
      source: "internal",
      event: "purchase",
      ecommerce: {
        transaction_id: leadId,
        affiliation: "Leads",
        value: 0.0,
        tax: 0.0,
        shipping: 0.0,
        currency: "",
        coupon: "",
        items: [
          {
            item_name: "Leads",
            item_id: leadId,
            Price: 0.0,
            item_brand: "",
            item_category: "Website Leads",
            item_category_2: "",
            item_category_3: "",
            item_category_4: "",
            item_category_5: "",
            item_variant: "",
            quantity: 1,
          },
        ],
      },
      contact_name: hash(response.fullName),
      contact_email: hash(response.email),
      contact_phone: hash(response.phone),
    });
  }
}

function pushRegInfoToGTM(response) {
  window.localStorage.setItem(
    "gtmData",
    JSON.stringify([
      {
        source: response.source,
        medium: response.medium,
        campaign: response.campaign,
        term: response.term,
        gclid: response.gclid,
        event: "Registration",
        transactionId: response.UniquePIN,
        transactionAffiliation: "Registration",
        transactionTotal: 0,
        transactionShipping: 0,
        transactionTax: 0,
        transactionCurrency: "USD",
        transactionProducts: [
          {
            sku: "Lead",
            category: "",
            name: "Lead",
            price: 0,
            quantity: 1,
          },
        ],
      },
    ])
  );

  pushRegistrationToGA4DataLayer(BRAND_NAME, response.UniquePIN, response);
}

export function processLeadSuccess(response, router) {
  pushRegInfoToGTM(response);
  if (router.pathname.includes("/franchise")) {
    setCookie("isregisteredfranchise", true, 365);
  } else {
    setCookie("isregistered", true, 365);
  }
  setCookie("common_cookie", response.signupurl, 365);
}
